import axios from 'axios';

export default class Resource {
  extend (args) {
    if (args) {
      Object.keys(args).forEach(arg => {
        this[arg] = args[arg]
      })
    }
  }

  static async list (query) {
    const { data } = await axios.get(this.ENDPOINT, { params: query });
    return data.map(d => new this(d));
  }

  static async get (obj) {
    let res
    if (typeof obj === 'string') {
      res = await axios.get(`${this.ENDPOINT}/${obj}`);
    } else {
      res = await axios.get(`${this.ENDPOINT}/getbyquery`, { params: obj });
    }
    return res.data && new this(res.data);
  }

  static async upload (data) {
    const res = await axios.post(`${this.ENDPOINT}`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    return res.data
  }

  async save () {
    let res = null;
    if (this._id) {
      this.updateDate = new Date()
      res = await axios.put(`${this.constructor.ENDPOINT}/${this._id}`, this);
    } else {
      res = await axios.post(this.constructor.ENDPOINT, this);
    }
    return res.data && new this.constructor(res.data);
  }

  async delete () {
    return await axios.delete(`${this.constructor.ENDPOINT}/${this._id}`);
  }
}
